import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAuthorityList,
  getCategoryList,
  amenitiesROWUtility,
  postSubmitAmenitiesROW,
  proposedUtilityAlignment,
  multiplePIUList,
  getSelectedStretch,
  getRowUtilities,
} from "../../services/apiEndPoints";

export const getCategoryListThunk = createAsyncThunk(
  "access/getCategoryList",
  async () => {
    try {
      const response = await getCategoryList();
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const proposedUtilityAlignmentThunk = createAsyncThunk(
  "access/proposedUtilityAlignment",
  async () => {
    try {
      const response = await proposedUtilityAlignment();
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const getAuthorityListThunk = createAsyncThunk(
  "access/getAuthorityList",
  async () => {
    try {
      const response = await getAuthorityList();
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const submitAmenitiesROWThunk = createAsyncThunk(
  "access/submitAmenitiesROW",
  async (payload: any) => {
    try {
      const response = await postSubmitAmenitiesROW(payload);
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

// ROW flow
export const getAmenitiesUtility = createAsyncThunk(
  "row/getAmenitiesUtility",
  async (payload: any) => {
    try {
      const response = await amenitiesROWUtility(payload);
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const multiplePIUListThunk = createAsyncThunk(
  "row/multiplePIUList",
  async (payload: any) => {
    try {
      const response = await multiplePIUList(payload);
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);


export const getSelectedStretchThunk = createAsyncThunk(
  "row/getSelectedStretch",
  async (payload: any) => {
    try {
      const response = await getSelectedStretch(payload);
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const getRowUtilitiesThunk = createAsyncThunk(
  "row/getRowUtilities",
  async () => {
    try {
      const response = await getRowUtilities();
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);
